import { useEffect, useRef, useState } from "react";
import { useLanguage } from "@/contexts/LanguageContext";

const RealInstagramFeed = () => {
  const { t } = useLanguage();
  const sectionRef = useRef<HTMLDivElement>(null);
  const [loadWidget, setLoadWidget] = useState(false);

  // Lazy-load Elfsight script only when section is near viewport
  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setLoadWidget(true);
          observer.disconnect();
        }
      },
      { rootMargin: "0px" }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!loadWidget) return;
    const existingScript = document.querySelector('script[src="https://static.elfsight.com/platform/platform.js"]');
    if (!existingScript) {
      const script = document.createElement("script");
      script.src = "https://static.elfsight.com/platform/platform.js";
      script.async = true;
      document.body.appendChild(script);
    }
  }, [loadWidget]);

  return (
    <section ref={sectionRef} className="py-16 md:py-24 bg-primary">
      <div className="container-custom">
        {/* Header */}
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-primary-foreground mb-3">
            Follow Us on Instagram
          </h2>
          <a
            target="_blank"
            rel="noopener noreferrer"
            className="text-lg md:text-xl font-medium text-gold-gradient inline-block hover:opacity-80 transition-opacity"
            href="https://www.instagram.com/arandialaw"
          >
            @arandialaw
          </a>
        </div>

        {/* Widget Area */}
        <div className="min-h-[400px] pt-8 pb-8 rounded-lg border border-white/15 backdrop-blur-xl bg-white/5 flex items-center justify-center">
          {loadWidget && (
            <div className="elfsight-app-96263e8b-0176-43f5-9037-0fe1fcf9b349 w-full" data-elfsight-app-lazy></div>
          )}
        </div>
      </div>
    </section>
  );
};

export default RealInstagramFeed;
